import { UamType } from '../enum';
import { Magnetic as Mi } from "../../../styles";
export const UAM_STYLES = new Map([
    [
        UamType.ACKNOWLEDGE,
        {
            icon: Mi.uamAcknowledgeIcon,
            color: Mi.uamAcknowledgeColor,
            background: Mi.uamAcknowledgeBackgroundColor
        }
    ],
    [
        UamType.ALERT,
        {
            icon: Mi.uamAlertIcon,
            color: Mi.uamAlertColor,
            background: Mi.uamAlertBackgroundColor
        }
    ],
    [
        UamType.CONFIRM,
        {
            icon: Mi.uamConfirmIcon,
            color: Mi.uamConfirmColor,
            background: Mi.uamConfirmBackgroundColor
        }
    ],
    [
        UamType.INSTRUCT,
        {
            icon: Mi.uamInstructIcon,
            color: Mi.uamInstructColor,
            background: Mi.uamInstructBackgroundColor
        }
    ],
    [
        UamType.HI_ALERT,
        {
            icon: Mi.uamHiAlertIcon,
            color: Mi.uamHiAlertColor,
            background: Mi.uamHiAlertBackgroundColor
        }
    ],
    [
        UamType.INSTRUCT_V2,
        {
            icon: Mi.bannerInstructUamIcon,
            color: Mi.bannerInstructColor,
            background: Mi.bannerInstructBackgroundColor
        }
    ]
]);
//# sourceMappingURL=uamStyles.js.map